var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-enter-cta"},[_c('div',{staticClass:"c-enter-cta__inner"},[_c('enter-cta-btn',{attrs:{"copy":_vm.copyButton()},on:{"clicked":_vm.clicked}}),_c('enter-cta-circles')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }